<template>
  <LegacyMobileDialog v-if="show_waiting" title="En espera" :subtitle="stock.ticker + ' · ' + (stock.nom || '')" @close="$emit('_closeWaitingValueWindow')">
    <p class="legacy-dialog-hint">Elige dónde seguir este valor antes de comprar.</p>
    <label class="legacy-dialog-field">Cartera
      <select :value="portfolio" @change="_changePortfolioSelected([$event.target.value])">
        <option disabled value="">Selecciona una cartera</option>
        <option v-for="item in user_portfolios" :key="item.name" :value="item.name">{{ item.value }}</option>
      </select>
    </label>
    <label class="legacy-dialog-field">Tipo de instrumento
      <select :value="instrument" @change="_changeInstrumentSelected([$event.target.value])"><option v-for="item in instrument_type_options" :key="item.name" :value="item.name">{{ item.value }}</option></select>
    </label>
    <p v-if="form_error" role="alert" class="error-message">{{ form_error }}</p>
    <div v-if="_requiresManualPayload && _hasManualFieldsToShow">
      <label v-if="_shouldShowManualField('currency')" class="manual-field">Divisa<select v-model="manual_form.currency"><option disabled value="">Selecciona una divisa</option><option v-for="currency in currency_options" :key="currency.value" :value="currency.value">{{ currency.label }}</option></select></label>
      <label v-if="_shouldShowManualField('in_price')" class="manual-field">Precio de entrada<input v-model.trim="manual_form.in_price" inputmode="decimal" /></label>
      <label v-if="_shouldShowManualField('support_price')" class="manual-field">Precio de soporte<input v-model.trim="manual_form.support_price" inputmode="decimal" /></label>
      <label v-if="_isCfdInstrument && _shouldShowManualField('cfd_margin')" class="manual-field">Margen CFD<input v-model.trim="manual_form.cfd_margin" inputmode="decimal" /></label>
    </div>
    <template #footer><button type="button" @click="backLabel ? $emit('back') : $emit('_closeWaitingValueWindow')">{{ backLabel || 'Cancelar' }}</button><button type="button" class="primary" :disabled="!portfolio" @click="_sendAction">Guardar en espera</button></template>
  </LegacyMobileDialog>
</template>



<script>
import LegacyMobileDialog from './LegacyMobileDialog.vue';
import APICaller from "@/shared/mixins/APICaller.js";
import inputFavorites from './configs/favorites-workspace.json';
import inputEditFavorites from './configs/edit-favorites-workspace.json';
import { mapGetters } from "vuex";
import SelectWallet from "@/features/stockchart/components/configs/select_waiting.json";
import SelectType from "@/features/stockchart/components/configs/select_type_instrument.json";

export default {
    mixins: [APICaller],
    components: { 
        LegacyMobileDialog
    },
    name: 'Workspaces',
    props: {
        stock: { type: Object },
        stocks: { type: Array },
        show_waiting: { type: Boolean},
        backLabel: { type: String, default: '' },
    },

    data: () => ({
        input_favorites : inputFavorites,
        input_edit_favorites : inputEditFavorites,
        workspaces: [],
        isClosingShieldOn: false,
        isCreating: false,
        isDeleting: false,
        isEditing: false,
        createWorkspaceNewName: "",
        editWorkspaceNewName: "",
        currentlyDeleting: {},
        currentlyEditing: {},
        createWorkspaceColor: "#000000",
        editWorkspaceColor: "#000000",
        user_portfolios:[],
        select_items: SelectWallet,
        portfolio_selected:[],
        helper_text_select:"",

        instrument_type_options: [{"name": 'STOCK', "value": 'Stock'},{"name": 'CFD', "value": 'CFD'}],
        currency_options: [
            { value: 'EUR', label: 'EUR - Euro' },
            { value: 'USD', label: 'USD - Dólar estadounidense' },
            { value: 'GBP', label: 'GBP - Libra esterlina' },
            { value: 'JPY', label: 'JPY - Yen japonés' },
            { value: 'CHF', label: 'CHF - Franco suizo' },
            { value: 'CAD', label: 'CAD - Dólar canadiense' },
            { value: 'AUD', label: 'AUD - Dólar australiano' },
        ],
        select_type: SelectType,

        button_name:"Enviar",
        button_key: "Send",
        active_button: true,

        portfolio: '',
        instrument: 'STOCK',
        manual_data_required: false,
        manual_form: {
            currency: '',
            in_price: '',
            support_price: '',
            support_date: '',
            cfd_margin: '',
        },
        manual_fields_to_show: [],
        form_error: '',



    }),

    watch: {
        // Update workspace isFavorite property each time a new stock is selected
        stock: {
            handler() {
                this._updateViewStockFavoriteWorkspaces();
            },
            deep: true,
        },
        instrument() {
            if (this._requiresManualPayload) {
                this._addManualFieldsToShow(this._missingManualFields());
            }
        },
    },

    computed: {
        ...mapGetters(['_g_positionFavoriteWorkspace']),
        _requiresManualPayload() {
            return this.manual_data_required || this._stockRequiresManualFields(this.stock);
        },
        _hasMissingManualFields() {
            return this._missingManualFields().length > 0;
        },
        _hasManualFieldsToShow() {
            return this.manual_fields_to_show.length > 0;
        },
        _isCfdInstrument() {
            return String(this.instrument).toUpperCase() === 'CFD';
        },
        _buttonName() {
            return this.button_name;
        },
    },

    created() {
    },

    mounted() {
        
        setTimeout(function(){
            this._initWorkspaces();
            this._getPortfolios();
            this._defaultPortfolio();
            this._initializeManualForm();
            this._setManualFieldsToShowFromMissing();
        }.bind(this), 100);
        
    },

    methods: {

        /*
         *   Operations - Creation, edition, deletion, set/unset as favorite for stock
         */

        // #Creation
        // Gets the favorite workspaces from the API and stores them in this.workspaces
        _initWorkspaces: function() {
            let success = response => {
                for (let index = 0; index < response.data.folders.length; index++) {
                        this.workspaces.push({
                            name: response.data.folders[index][0],
                            color: response.data.folders[index][1],
                            isFavorite: false,
                        });
                    }
            };

            let url = '/api/v1/stock-finder/favorite-folder/list';
            
            const successHandler = new APICaller.SuccessHandler(success);
            const failureHandler = new APICaller.FailureHandler('094', 'Error cargando lista de favoritos.');

            this._getAPICall(url, successHandler, failureHandler);
            
        },    
        // Terminates ongoing edition without saving if there's any, displays creation menu
        _createWorkspacePrepare: function() {
            this._editWorkspaceCancel();
            this.createWorkspaceColor = this._generateRandomHexColor();
            this.isCreating = true;
        },

        _updateViewStockFavoriteWorkspaces: function() {
            this._resetManualForm();
            this._initializeManualForm();
            this._setManualFieldsToShowFromMissing();
            for(let workspace in this.workspaces){
                if( this.stock.folder_name.indexOf(this.workspaces[workspace].name) != -1) {
                    this.workspaces[workspace].isFavorite = true;
                }
                else {
                    this.workspaces[workspace].isFavorite = false;
                }
            }
        },

        _getPortfolios: function(){
            let success = (response) => {                
                response.data.forEach(element => {
                this.user_portfolios.push({"name": element.idc, "value": element.name});
            });
            };

            let url = '/api/v1/portfolio/list';

            const successHandler = new APICaller.SuccessHandler(success);
            const failureHandler = new APICaller.FailureHandler('095', 'Error cargando lista de carteras.');

            this._getAPICall(url, successHandler, failureHandler);

        },


        _sendAction: function(){
            this.form_error = '';

            if (this._requiresManualPayload) {
                this._sendManualWaitingAction();
                return;
            }

            let params = new URLSearchParams();
            //params.append('stocks', JSON.stringify([this.stock]));
            params.append('instrument_type', this.instrument);
            params.append('ticker', this.stock.ticker);
            if (!this._isEmpty(this.stock.tipus_entrada)) params.append('entry_type', this.stock.tipus_entrada);
            if (!this._isEmpty(this.stock.direccio)) params.append('direction', this.stock.direccio);

            let url = '/api/v1/portfolio/waitings/add/' + this.portfolio;


            let success = (response) => {
                if (response.data && response.data.status === 'requires_manual_data') {
                    this.manual_data_required = true;
                    this._initializeManualForm();
                    this._setManualFieldsToShowFromMissing();
                    this._sendManualWaitingAction();
                    return;
                }

                this.$vueOnToast.pop('success', "Ticker " + this.stock.ticker, "Enviado a correctamente!");
                this.$emit("waiting-added")
                this._manageExitClicksBehavior()
                if(this.stock.waitings_portfolio_name === undefined) {
                    this.stock.waitings_portfolio_name = [this.portfolio];
                }
                else {
                    this.stock.waitings_portfolio_name.push(this.portfolio);
                }
            };

            const successHandler = new APICaller.SuccessHandler(success);
            const failureHandler = new APICaller.FailureHandler('280', 'Error agregando ticker a la cartera.');

            this._postAPICall(url, params, successHandler, failureHandler);

        },

        _sendManualWaitingAction: function(){
            this._initializeManualForm();
            const missingFields = this._missingManualFields();
            if (missingFields.length > 0) {
                this._addManualFieldsToShow(missingFields);
                this.form_error = 'Completa los datos necesarios para añadir este valor.';
                return;
            }

            let params = this._buildManualWaitingPayload();
            let url = '/api/v1/portfolio/waitings/add/' + this.portfolio;

            let success = (response) => {
                if (response.data && response.data.status === 'requires_manual_data') {
                    this._addManualFieldsToShow(response.data.required_fields || this._missingManualFields());
                    this.form_error = 'Completa los datos necesarios para añadir este valor.';
                    return;
                }
                if (response.data && response.data.status && response.data.status !== 'ok') {
                    this.$vueOnToast.pop('error', "Ticker " + this.stock.ticker, "No se ha podido añadir a cartera.");
                    return;
                }

                this.$vueOnToast.pop('success', "Ticker " + this.stock.ticker, "Enviado a correctamente!");
                this.$emit("waiting-added")
                this._manageExitClicksBehavior()
                if(this.stock.waitings_portfolio_name === undefined) {
                    this.stock.waitings_portfolio_name = [this.portfolio];
                }
                else {
                    this.stock.waitings_portfolio_name.push(this.portfolio);
                }
            };

            const successHandler = new APICaller.SuccessHandler(success);
            const failureHandler = new APICaller.FailureHandler('281', 'Error agregando ticker a la cartera.');

            this._postAPICall(url, params, successHandler, failureHandler);
        },

        _buildManualWaitingPayload: function() {
            const params = new URLSearchParams();
            params.append('instrument_type', this.instrument);
            params.append('ticker', this.stock.ticker);
            params.append('entry_type', this._stockValue(this.stock, ['tipus_entrada', 'entry_type']) || 0);
            params.append('direction', this._stockValue(this.stock, ['direccio', 'direction']) || 1);
            params.append('currency', this._manualValue('currency'));
            params.append('in_price', this._manualValue('in_price'));
            params.append('support_price', this._manualValue('support_price'));
            params.append('support_date', this._manualValue('support_date') || this._defaultSupportDate());
            params.append('is_ipo', this._stockValue(this.stock, ['is_ipo', 'ipo']) || 0);
            if (this._isCfdInstrument) {
                params.append('cfd_margin', this._manualValue('cfd_margin'));
            }
            return params;
        },

        _initializeManualForm: function() {
            this.manual_form.currency = this.manual_form.currency || this._normalizeCurrency(this._stockValue(this.stock, ['divisa', 'currency']));
            this.manual_form.in_price = this.manual_form.in_price || this._stockValue(this.stock, ['in_price', 'real_entry', 'entry_price', 'entrada']);
            this.manual_form.support_price = this.manual_form.support_price || this._stockValue(this.stock, ['support_price', 'soport', 'support', 'out_price']);
            this.manual_form.support_date = this.manual_form.support_date || this._dateForInput(this._stockValue(this.stock, ['support_date', 'data_soport', 'fecha_soporte']));
            this.manual_form.cfd_margin = this.manual_form.cfd_margin || this._stockValue(this.stock, ['cfd_margin']);
        },

        _resetManualForm: function() {
            this.manual_form = {
                currency: '',
                in_price: '',
                support_price: '',
                support_date: '',
                cfd_margin: '',
            };
            this.manual_fields_to_show = [];
        },

        _setManualFieldsToShowFromMissing: function() {
            this.manual_fields_to_show = this._missingManualFields();
        },

        _addManualFieldsToShow: function(fields) {
            const userEditableFields = fields.filter(field => field !== 'support_date');
            this.manual_fields_to_show = Array.from(new Set(this.manual_fields_to_show.concat(userEditableFields)));
        },

        _missingManualFields: function() {
            const fields = ['currency', 'in_price', 'support_price'];
            if (this._isCfdInstrument) fields.push('cfd_margin');
            return fields.filter(field => this._manualFieldIsMissing(field));
        },

        _shouldShowManualField: function(field) {
            return this.manual_fields_to_show.includes(field);
        },

        _manualFieldIsMissing: function(field) {
            const value = this._manualValue(field);
            if (this._isEmpty(value)) return true;
            if (field === 'currency') return !/^[A-Z]{3,6}$/.test(value);
            if (field === 'support_date') return !/^\d{4}-\d{2}-\d{2}$/.test(value);
            return !this._isValidNumber(value);
        },

        _isValidNumber: function(value) {
            const normalized = String(value).replace(',', '.');
            return normalized !== '' && !isNaN(parseFloat(normalized)) && isFinite(normalized);
        },

        _manualValue: function(field) {
            if (field === 'currency') {
                return this._normalizeCurrency(this.manual_form.currency);
            }
            if (['in_price', 'support_price', 'cfd_margin'].includes(field)) {
                return String(this.manual_form[field]).replace(',', '.');
            }
            return this.manual_form[field];
        },

        _stockRequiresManualFields: function(stock = this.stock) {
            return this._isEmpty(this._stockValue(stock, ['tipus_entrada', 'entry_type'])) || this._isEmpty(this._stockValue(stock, ['direccio', 'direction']));
        },

        _stockValue: function(stock, fields) {
            if (!stock) return '';

            for (let index = 0; index < fields.length; index++) {
                let value = stock[fields[index]];

                if (!this._isEmpty(value)) {
                    return value;
                }
            }

            return '';
        },

        _isEmpty: function(value) {
            return value === undefined || value === null || value === '';
        },

        _normalizeCurrency: function(currency) {
            currency = currency ? String(currency).toUpperCase() : '';

            if (currency.length === 6) {
                return currency.substring(3, 6);
            }

            return currency;
        },

        _dateForInput: function(date) {
            if (this._isEmpty(date)) return '';
            date = String(date).trim();
            if (date === '01/01/1970' || date === '01-01-1970' || date === '1970-01-01') return '';
            if (/^\d{4}-\d{2}-\d{2}$/.test(date)) return date;
            if (/^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
                const parts = date.split('/');
                return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
            if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
                const parts = date.split('-');
                return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
            return '';
        },

        _defaultSupportDate: function() {
            const date = new Date();
            const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
            return localDate.toISOString().slice(0, 10);
        },

        _defaultPortfolio: function(){
            let success = (response) => {               
                this.portfolio_selected.push({"name": response.data.idc, "value": response.data.name});
                if (!this.portfolio) this.portfolio = String(response.data.idc);
            };

            let url = '/api/v1/portfolio-invest-preferences';

            const successHandler = new APICaller.SuccessHandler(success);
            const failureHandler = new APICaller.FailureHandler('096', 'Error cargando preferencias de inversión.');

            this._getAPICall(url, successHandler, failureHandler);
        },

        _changePortfolioSelected: function(value){            
            this.portfolio = value[0];

        },
        _changeInstrumentSelected: function(value){
            this.instrument = value[0];
        },

        /*_isInViewport: function(){
            var y = this.$refs.pico.getBoundingClientRect().top;
            return y <= window.innerHeight;
        },*/

       


        // Decides the behavior of a click on a closing triggering position
        // If there's an ongoing operation it will be cancelled
        // If there's not then the window will close
        _manageExitClicksBehavior: function() {
            let that = this;
            if(!this.isEditing && !this.isCreating && !this.isDeleting){
                setTimeout(function() {
                    if (!that.isClosingShieldOn) {
                        that.$emit('_closeWaitingValueWindow');
                    }
                    that.isClosingShieldOn = false;

                }, 10);
            } else {
                setTimeout(function() {
                    if(!that.isClosingShieldOn) {
                        that._cancelOngoingOperations();
                    }
                    that.isClosingShieldOn = false;
                },10);
            }

        },
        

        // Sets a flag necessary for window closing behaviour
        _turnOnClosingShield: function() {
            this.isClosingShieldOn = true;
        },


        /*
         *   Misc
         */

        //Generates a random color for the swatch
        _generateRandomHexColor: function() {
            let randomColor = Math.floor(Math.random()*16777215).toString(16);
            return "#" + randomColor;
        },
  },
}
</script>


<style lang="scss" scoped>
    
    header{
        width: 100%;
    }

    .workspace-name-container{
        text-align:center; 
        margin-top:15px;
    }

    .addwaitings-workspace-style{
        position: absolute;
        min-height: 400px;
        width: 320px;
        background: #F3F4F7;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        top: 140px;
        left: 10%;
    }

    @media screen and(max-width: 350px){
        .addwaitings-workspace-style{
            width: 80%
        }

    }

    @media screen and(min-width: 351px) and(max-width: 391px){
        .addwaitings-workspace-style{
            width: 110%;
        }

    }

    @media screen and(min-width: 392px) and(max-width: 500px){
        .addwaitings-workspace-style{
            width: 120%;
        }

    }

    .user-workspaces {
        width: 300px;
        z-index: 999999;
        display: block !important;
        color: black;
        text-align: left;
        position: absolute;
        text-decoration: none;
        background-color: #f3f4f7;
        border-radius: 5px;       
    }

    .title-favorites{
        margin-top: 10px; 
        margin-left: 20px;
        font-size: 15px;
    }

    .add-button-container{
        text-align: center;
        position:relative;
    }

    .close {
        position: absolute;
        right: 4px;
        cursor:pointer;
    }

    #workspace-select-favorite-icon {
        display: inline-block;
    }
    .remove-text-container{
        text-align:center;
        font-size:13px;
        margin-top:50px;
    }
    .remove-star-container{
        text-align:center;
        margin-top:25px;
        margin-bottom:25px;
    }
    .remove-button-container input{
        width:140px;
        height:35px;
        color:white;
        font-weight:bold;
        background-color:#00aedd;
        border-radius:30px;
        border-color:transparent;
       
    }
    .cancel-button-container input{
        border:none;
        color:#2e81a5;
        font-weight:bold;
        margin-top:15px;

    }

    .remove-star-containter{
        text-align: center;
        margin-bottom: 20px;
    }

    .cartera-1{
        margin-top: 30px;
        width: 70%;
        margin-left: 47px;
    }

    .button-addwaitings-style{
        text-align:center;
    }

    .button-class{
        margin-top: 50px;
    }

    .manual-fields-mobile {
        margin-top: 20px;
    }

    .manual-field {
        display: flex;
        flex-direction: column;
        margin-bottom: 12px;
        font-size: 13px;
    }

    .manual-field label {
        margin-bottom: 4px;
        font-weight: 600;
    }

    .manual-field input,
    .manual-field select {
        height: 34px;
        border: 1px solid #c8cbd2;
        border-radius: 4px;
        padding: 6px 8px;
        box-sizing: border-box;
    }

    .error-message {
        color: #c62828;
        font-size: 12px;
        margin-bottom: 10px;
    }
</style>
